"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Coordinate = _interopRequireDefault(require("../geom/Coordinate"));

var _SegmentPointComparator = _interopRequireDefault(require("./SegmentPointComparator"));

var _Comparable = _interopRequireDefault(require("../../../../java/lang/Comparable"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SegmentNode =
/*#__PURE__*/
function () {
  function SegmentNode() {
    _classCallCheck(this, SegmentNode);

    SegmentNode.constructor_.apply(this, arguments);
  }

  _createClass(SegmentNode, [{
    key: "getCoordinate",
    value: function getCoordinate() {
      return this.coord;
    }
  }, {
    key: "print",
    value: function print(out) {
      out.print(this.coord);
      out.print(" seg # = " + this.segmentIndex);
    }
  }, {
    key: "compareTo",
    value: function compareTo(obj) {
      var other = obj;
      if (this.segmentIndex < other.segmentIndex) return -1;
      if (this.segmentIndex > other.segmentIndex) return 1;
      if (this.coord.equals2D(other.coord)) return 0;
      return _SegmentPointComparator.default.compare(this._segmentOctant, this.coord, other.coord);
    }
  }, {
    key: "isEndPoint",
    value: function isEndPoint(maxSegmentIndex) {
      if (this.segmentIndex === 0 && !this._isInterior) return true;
      if (this.segmentIndex === maxSegmentIndex) return true;
      return false;
    }
  }, {
    key: "isInterior",
    value: function isInterior() {
      return this._isInterior;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SegmentNode;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Comparable.default];
    }
  }]);

  return SegmentNode;
}();

exports.default = SegmentNode;

SegmentNode.constructor_ = function () {
  this._segString = null;
  this.coord = null;
  this.segmentIndex = null;
  this._segmentOctant = null;
  this._isInterior = null;
  var segString = arguments[0],
      coord = arguments[1],
      segmentIndex = arguments[2],
      segmentOctant = arguments[3];
  this._segString = segString;
  this.coord = new _Coordinate.default(coord);
  this.segmentIndex = segmentIndex;
  this._segmentOctant = segmentOctant;
  this._isInterior = !coord.equals2D(segString.getCoordinate(segmentIndex));
};